import {createSlice} from '@reduxjs/toolkit';
import {getInitialMenuForUser} from "../../utils/getInitialMenuForUser";

const storedUser = localStorage.getItem("user");
const userTypeFromLocalStorage = storedUser ? JSON.parse(storedUser).userType : 1;
const menuSlice = createSlice({
    name: 'menu',
    initialState: {  
        activeItem: getInitialMenuForUser(userTypeFromLocalStorage),
        version: 0,
    },
    reducers: {
        setActiveItem: (state, action) => {
            state.activeItem = action.payload;
            state.version += 1;
        },
    },
    
});

export const { setActiveItem } = menuSlice.actions;
export default menuSlice.reducer;